import type { HomeChatDTO } from "@roomate/core";

/** What a source link in a Home chat answer opens, shown as a small mark beside it. */
export function sourceKind(href: string): "task" | "decision" | "project" | "page" {
  if (href.startsWith("/tasks/")) return "task";
  if (href.startsWith("/decisions/") || href === "/inbox") return "decision";
  if (href.startsWith("/projects/")) return "project";
  return "page";
}

/** A Home chat request as GET /home-box/:chatId returns it: the hub's DTO with the filed idea typed for what this page reads. */
export type HomeChat = Omit<HomeChatDTO, "filed"> & { filed: { specTask: { number: number }; specAgent: { name: string } | null } | null };

/** Fallback poll for the answer. homebox.updated refetches at once while the socket is up, so the poll is slow then (each GET sweeps stale chats on the hub). */
export function homeChatPollMs(connected: boolean): number {
  return connected ? 8_000 : 1_500;
}

/** The quiet line under an answer: who wrote it, or that it is the plain status summary. */
export function answeredByLine(by: { fallback: boolean; agent: string; model: string | null }): string {
  if (by.fallback) return "quick summary";
  return ["answered by " + (by.agent || "an agent"), by.model].filter(Boolean).join(" · ");
}
